export default {
  today: 'Astăzi',
  tomorrow: 'Mâine',
};
